import * as React from 'react';
import { ISpinnerProps } from './ISpinner';

const Spinner = (props: ISpinnerProps) => {
    return (
        <div className='d-flex justify-content-center align-items-center h-100'>
            <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
            </div>
        </div>
    );
};

export default Spinner;
